

          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._newFanalertInfo = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {};
  var _ext = _swig.extensions,
    _output = "";
_output += "<div id=\"fanalert-info\" class=\"new-fanalert__wrap\">\n    <div class=\"new-fanalert__form-body\">\n        <div class=\"new-fanalert__copy-wrap\">\n            <div>\n                <h3 class=\"new-fanalert__copy-title new-fanalert__form-copy-title\">Fandango FanAlert&trade;</h3>\n\n                <p class=\"dark__text\">\n                    Stay informed when tickets become available.\n                    Plus, for select titles, be the first to know when new content drops, get access to exclusive videos, offers, and more!\n                </p>\n            </div>\n        </div>\n    </div>\n</div>\n";

  return _output;

}
          module.exports = window.Fandango.templates._newFanalertInfo;
          
          